export const Corporate = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Корпоративным клиентам</h1>
      <p>Информация для корпоративных клиентов...</p>
    </div>
  );
};